<script setup>

import { onMounted, ref } from 'vue'

import { usePortalStore } from '@/stores/portal.store.js'

const portalStore = usePortalStore()

const letterOfAppointment = ref(null)
const letterOfAppointmentDialogShow = ref(false)

onMounted(async() => {
  const res = await portalStore.fetchLetterOfAppointmentAsync()
  if (res) {
    letterOfAppointment.value = res.data

    if (letterOfAppointment.value.alreadyAccepted) {
      return
    }

    if (letterOfAppointment.value.TipoLink === 0) {
      letterOfAppointmentDialogShow.value = true
    }
  }
})

const onAcceptLetterOfAppointment = async() => {
  letterOfAppointment.value.loading = true
  window.open(letterOfAppointment.value.Link, '_blank')
  let counter = 0
  const interval = setInterval(async() => {
    const res = await portalStore.fetchLetterOfAppointmentAsync()
    if (res?.data?.alreadyAccepted) {
      clearInterval(interval)
      letterOfAppointment.value.loading = false
      letterOfAppointmentDialogShow.value = false
    } else {
      counter++
      if (counter > 10) {
        clearInterval(interval)
        letterOfAppointment.value.loading = false
      }
    }
  }, 10000)
}
</script>
<template>
  <q-dialog
    v-model="letterOfAppointmentDialogShow"
    persistent
  >
    <q-card>
      <q-card-section>
        <div class="text-h6">
          {{ $t('common.letterOfAppointment.header') }}
        </div>
      </q-card-section>
      <q-card-section class="q-pt-none">
        {{ $t('common.letterOfAppointment.body') }}
      </q-card-section>
      <q-card-section
        v-if="letterOfAppointment.GiorniDisponibili >= 0"
        class="q-pt-none"
      >
        {{ $t('common.letterOfAppointment.countDown', { counter: letterOfAppointment.GiorniDisponibili }) }}
      </q-card-section>
      <q-card-section
        v-else
        class="q-pt-none red"
      >
        {{ $t('common.letterOfAppointment.expiration') }}
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          flat
          color="primary"
          :label="$t('common.accept')"
          :loading="letterOfAppointment.loading"
          :style="{ 'width': letterOfAppointment.loading ? '15rem' : 'auto' }"
          @click="onAcceptLetterOfAppointment"
        >
          <template #loading>
            {{ $t('common.verifyingAcceptance') }}
            <q-spinner class="on-right" />
          </template>
        </q-btn>
        <q-btn
          v-if="letterOfAppointment.GiorniDisponibili >= 0"
          v-close-popup
          flat
          :label="$t('common.cancel')"
          color="primary"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>
<style lang="scss">
.red {
  color: $red;
}
</style>
